/* istanbul ignore file */
import OVERVIEW_ROUTES from './subroutes/overview.routes.js';
import PROJECTS_ROUTES from './subroutes/projects.routes.js';
import PIPELINES_ROUTES from './subroutes/pipelines.routes.js';
import LINGUISTIC_RESOURCES_ROUTES from './subroutes/linguistic-resources.routes.js';
import REPORTING_ROUTES from './subroutes/reporting.routes.js';
import TRANSLATIONS_AUDITING_ROUTES from './subroutes/auditing.routes.js';
import QUALITY_ANNOTATIONS_ROUTES from './subroutes/quality-annotations.routes.js';
import USER_ROUTES from './subroutes/user.routes.js';
import INTEGRATIONS_ROUTES from './subroutes/integrations.routes.js';
import BILLING_ROUTES from './subroutes/billing.routes.js';
import SUBSCRIPTION_ROUTES from './subroutes/subscriptions.routes.js';
import CUSTOMER_ROUTES from './subroutes/customers.routes.js';
import PROFILE_ROUTES from './subroutes/profile.routes.js';

export const ROUTES = {
	...OVERVIEW_ROUTES,
	...PROJECTS_ROUTES,
	...PIPELINES_ROUTES,
	...LINGUISTIC_RESOURCES_ROUTES,
	...REPORTING_ROUTES,
	...TRANSLATIONS_AUDITING_ROUTES,
	...QUALITY_ANNOTATIONS_ROUTES,
	...USER_ROUTES,
	...INTEGRATIONS_ROUTES,
	...BILLING_ROUTES,
	...SUBSCRIPTION_ROUTES,
	...CUSTOMER_ROUTES,
	...PROFILE_ROUTES,
};
